// src/main.jsx
import React, { Suspense } from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import './styles/global.css';
import './styles/premium.css';
import './i18n';
import { ThemeProvider } from './contexts/ThemeContext';
import { DesignProvider } from './contexts/DesignContext';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    {/* DesignProvider owija wszystko, by design był globalnie dostępny */}
    <DesignProvider>
      {/* ThemeProvider owija wszystko inne, aby kontekst był globalnie dostępny */}
      <ThemeProvider>
        <Suspense fallback="Loading...">
          <BrowserRouter
            future={{ v7_relativeSplatPath: true, v7_startTransition: true }}
          >
            <App />
          </BrowserRouter>
        </Suspense>
      </ThemeProvider>{' '}
      {/* <--- Koniec owinięcia */}
    </DesignProvider>
  </React.StrictMode>
);
